import { Component, OnInit } from '@angular/core';
import { HelperProvider } from '../../providers/helper.provider';
import { IRegister } from '../../interfaces/register.interface';
import { OfficeHelperService } from '../../providers/office-helper/office-helper.service';
import { IOfficeData } from '../../interfaces/office.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationLoaderService } from '../../core/translation-loader.service';
import { locale as english } from '../../i18n/en';
import { locale as polish } from '../../i18n/pl';
import { environment } from '../../../environments/environment.prod';
import { AlertController } from '@ionic/angular';
import { Camera, CameraOptions } from '@awesome-cordova-plugins/camera/ngx';
// import { FileTransfer, FileUploadOptions, FileTransferObject } from '@awesome-cordova-plugins/file-transfer/ngx';
// import { File } from '@awesome-cordova-plugins/file';

@Component({
  selector: 'issue-reporter',
  templateUrl: './issue-reporter.page.html',
  styleUrls: ['./issue-reporter.page.scss'],
})
export class IssueReporterPage implements OnInit {

  registerList: Array<IRegister>;
  registerRecord: any = {};
  base64Image;
  types = [
    { label: 'blocker', title: 'Blocker' },
    { label: 'issueToSolve', title: 'Issue To solve' },
    { label: 'enhancement', title: 'Enhancement' }
  ];
  loading: HTMLIonLoadingElement;
  constructor(
    private helperService: HelperProvider,
    private officeHelper: OfficeHelperService,
    private route: ActivatedRoute,
    private translationLoader: TranslationLoaderService,
    private alertCtrl: AlertController,
    private router: Router,
    private camera: Camera,
    // private transfer: FileTransfer, 
    // private file: File
  ) { }

  ngOnInit() {
    this.translationLoader.loadTranslations(english, polish);

    this.registerRecord.type = this.route.snapshot.params['type'] || '';
    this.registerRecord.regId = this.route.snapshot.params['regId'] || '';
    this.registerRecord.regName = this.route.snapshot.params['regName'] || '';

    // this.getRegisterList();
    this.officeHelper.getLocalOfficeData()
    .then((officeData: IOfficeData) => {
      this.registerRecord['officeName'] = officeData.name || '';
      this.registerRecord['officeId'] = officeData._id || '';
    }).catch(err => {
      console.log(err);
    });
  }

  async getRegisterList() {
    const loading = await this.helperService.showLoading('Getting Data');
    this.helperService.getRegisterList()
    .then((registerList: Array<IRegister>) => {
      registerList = registerList || [];
      this.registerList = registerList.filter((register) => (register && register.mobileIssueReporter));
      loading.dismiss();
    }).catch(err => {
      alert(err);
      console.log(err);
      loading.dismiss();
    });
  }

  onRegisterChange() {
    console.log(this.registerRecord);
    this.registerList.forEach((register: IRegister) => {
      if (register._id === this.registerRecord['regId']) {
        this.registerRecord['regName'] = register.name || '';
      }
    });
  }

  save() {
    if (this.registerRecord['regId'] && this.registerRecord['regId'] !== 'null') {
      this.toggleLoading(true);
      this.helperService.createRegisterRecord(this.registerRecord['regId'], this.registerRecord)
      .then((data) => {
        return this.uploadImg(this.registerRecord['regId'], (data && data['_id']));
      }).then((data) => {
        this.helperService.showToast('Thanks for submitting report');
        this.toggleLoading(false);
        this.presentAlert();

      }).catch(err => {
        console.log(err);
        this.toggleLoading(false);
        this.helperService.showToast(err || 'Some error occurred while creating issue');
      });
    } else {
      // this.helperService.showToast('Please Select register first');
      this.toggleLoading(true);

      this.helperService.postRequest(`${environment.serverUrl}api/issue-reporter`, this.registerRecord)
      .then((data) => {
        this.helperService.showToast('Thanks for submitting report');
        this.toggleLoading(false);
        this.presentAlert();
      }).catch(err => {
        console.log(err);
        this.toggleLoading(false);
        this.helperService.showToast(err || 'Some error occurred while creating issue');
      });
    }
  }

  async presentAlert() {
    const alert = await this.alertCtrl.create({
      header: 'Issue Reported',
      subHeader: 'Thanks for reporting issue, we will contact soon.',
      buttons: ['Okay']
    });
    alert.present();
    alert.onDidDismiss()
    .then(() => {
      this.router.navigateByUrl(`/dashboard`);
    }).catch(err => {
      console.log(err);
    });
  }

// ['PHOTOLIBRARY', 'CAMERA', 'SAVEDPHOTOALBUM']
  takePhoto(pictureSourceType: number) {
    try {
    const options: CameraOptions = {
      quality: 40,
      destinationType: this.camera.DestinationType.FILE_URI,
      allowEdit: true,
      encodingType: this.camera.EncodingType.JPEG,
      sourceType: pictureSourceType,
      mediaType: this.camera.MediaType.PICTURE
    };
    
    this.camera.getPicture(options).then((imageData) => {
     this.base64Image = imageData;
    }, (err) => {
     // Handle error
     alert(err);
    });
  } catch (err) {
      console.log(err);
      alert(err);
    }
  }

  uploadImg(regId: string, recId: string) {
    // if (this.base64Image) {
    //   const fileTransfer: FileTransferObject = this.transfer.create();
    //   const options: FileUploadOptions = {
    //     fileKey: 'uplFile',
    //     fileName: 'name.jpg',
    //     chunkedMode: false,
    //     httpMethod: 'post',
    //     mimeType: 'image/jpeg',
    //     headers: {}
    //  };
   
    //  const officeId = JSON.parse(localStorage.getItem('ngStorage-selectedOffice'))['_id'];
    //  const profile = (localStorage.getItem('ngStorage-profile')) ? JSON.parse(localStorage.getItem('ngStorage-profile')) : null;

    //  // tslint:disable-next-line:max-line-length
    //  return fileTransfer.upload(this.base64Image, `${environment.serverUrl}api/files/${officeId}/upload?creatorId=${profile['_id']}&creatorLogin=${profile['login']}&officeId=${officeId}&recId=${recId}&regId=${regId}`, options);
    // } else {
    //   return null;
    // }
  }

  async toggleLoading(show: boolean) {
    if (show) {
      this.loading = await this.helperService.showLoading('Uploading Data...');
    } else {
      if (this.loading) {
        this.loading.dismiss();
      }
    }
  }

}
